import { observer } from 'mobx-react';
import { notYetTranslatedText, T } from '../../../../../../../../Translations';
import CarouselDisplayTypeChoice from '../../../../../../../Cutesies/CarouselDisplayTypeChoice';
import ListDisplayTypeChoice from '../../../../../../../Cutesies/ListDisplayTypeChoice';
import GridDisplayTypeChoice from '../../../../../../../Cutesies/GridDisplayTypeChoice';
import DisplayTypeChoice from '../../../../../LearningDesigns/Components/DisplayTypeChoice';
import { ProductCollectionDisplayType } from '../../../../../../Types';
import { equals } from '@execonline-inc/collections';
import { Dispatch, SetStateAction } from 'react';
import { LearningDesignSection } from '../../../../../Types';

interface Props {
  section: LearningDesignSection;
  displayType: string;
  onChange: Dispatch<SetStateAction<string>>;
}

const isDisplayTypeChecked = (
  selectedDisplayType: string,
  targetDisplayType: ProductCollectionDisplayType,
) => equals(selectedDisplayType, targetDisplayType);

function DisplayType({ displayType, onChange, section }: Props) {
  return (
    <div className="mb-6">
      <div className="flex flex-row mb-4 text-sm font-semibold">
        <span>
          <T kind="Section Display Type" />
        </span>
      </div>
      <div className="flex flex-row flex-wrap gap-y-3 gap-x-4">
        <DisplayTypeChoice
          label={notYetTranslatedText('Carousel')}
          onClick={() => onChange('carousel')}
          isChecked={isDisplayTypeChecked(displayType, 'carousel')}
          icon={<CarouselDisplayTypeChoice />}
          section={section}
        />
        <DisplayTypeChoice
          label={notYetTranslatedText('List')}
          onClick={() => onChange('list')}
          isChecked={isDisplayTypeChecked(displayType, 'list')}
          icon={<ListDisplayTypeChoice />}
          section={section}
        />
        <DisplayTypeChoice
          label={notYetTranslatedText('Grid')}
          onClick={() => onChange('grid')}
          isChecked={isDisplayTypeChecked(displayType, 'grid')}
          icon={<GridDisplayTypeChoice />}
          section={section}
        />
      </div>
    </div>
  );
}

export default observer(DisplayType);
